export default __webpack_public_path__ + "static/media/livebook.742442fe.jpg";